import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import PageHeader from '@common/PageHeader'
import mainStore from '@components/Main/store'
import { RouterView } from '@merchant-backend/common-components'
import { getAuthIdList, getMerchantInfo } from '@util'
import 'antd4/lib/grid/style/index.css'
import { DatePicker, message, Radio, Select, Tag, TreeSelect } from 'hljd'
import { toJS } from 'mobx'
import { inject, observer } from 'mobx-react'
import React, { Component } from 'react'
import { Link } from 'react-router'
import Category from '../../common/Category'
import CheckInput from '../../common/CheckInput'
import CoverImageUpload from '../../common/CoverImageUpload'
import CoverVideoUpload from '../../common/CoverVideoUpload'
import InputPrice from '../../common/InputPrice'
import PlanField from '../../common/PlanField'
import WeddingPlace from '../../common/WeddingPlace'
import { formItemLayout } from '../../constants'
import { checkEmoji, validatorCoverPath } from '../../utils'
import styles from './style.module.less'

const FormItem = Form.Item
const CheckableTag = Tag.CheckableTag

@inject('store')
@observer
class BaseInfo extends Component {
  showShuiJing = (is_add_form, isFromShuijing) => {
    const { isPaid, isExpired } = mainStore
    const { is_franchisee } = getMerchantInfo()
    const l = getAuthIdList()
    const hasShuiJingAuth =
      is_franchisee == 1 || (l.includes('-1') || l.includes('2_1_1_3'))
    return (
      hasShuiJingAuth && is_add_form && isPaid && !isExpired && !isFromShuijing
    )
  }

  render() {
    const { id, form, store, isFromShuijing } = this.props
    const {
      case_cate,
      form_init,
      case_detail,
      hotels,
      hotelBallroom,
      onSearchHotel,
      onSearchHotelBallroom,
      checkImg: { checkCMYK },
      properties,
      is_add_form,
      shuijingCategoryList,
      merchant_info,
      topWeddingTags,
      selectedTopWeddingTag,
      changeTopWeddingTags,
      clearHotelBallroom,
      setPropertyId,
      grayTestFlag,
      examinationPassed
    } = store
    const {
      getFieldDecorator,
      getFieldValue,
      getFieldError,
      setFieldsValue
    } = form

    const form_default = toJS(form_init)

    // 如果分类被删除了，就不显示
    const idx = case_cate.findIndex(
      item => item.id == form_default._merchant_category_id
    )
    const _merchant_category_id =
      idx > -1 ? form_default._merchant_category_id : undefined

    const _show_in_shuijing =
      getFieldValue('_show_in_shuijing') ?? form_default._show_in_shuijing

    // 是否为高定商家
    const top_wedding = !!merchant_info.top_wedding

    // 审核通过且为整改城市不可编辑
    const disabled =
      grayTestFlag && case_detail?.normative == 1 && examinationPassed

    const header = [
      <Link to="/localMerchant/case">案例管理</Link>,
      id ? '编辑案例' : '发布案例'
    ]

    return (
      <RouterView
        title="案例基础信息"
        header={header}
        bodyStyle={{ padding: '24px 24px 0' }}
        titleStyle={{ height: 48, padding: '0 24px' }}
        viewStyle={{ margin: '0 20px 4px 20px' }}
      >
        {!!case_detail?.reason &&
          case_detail?.status == 3 && (
            <div style={{ margin: '10px 0 30px 0' }}>
              <PageHeader
                type="error"
                title={`审核未通过原因：${case_detail.reason}`}
                key="coverPathText"
              />
            </div>
          )}

        <FormItem label="案例分类" {...formItemLayout}>
          {getFieldDecorator('_merchant_category_id', {
            initialValue: _merchant_category_id
          })(<Category />)}
        </FormItem>

        <FormItem label="案例标题" {...formItemLayout}>
          {getFieldDecorator('title', {
            initialValue: form_default.title || '',
            rules: [
              {
                required: true,
                message: '请输入案例标题'
              },
              {
                min: 12,
                message: '案例标题字数不能少于12个字'
              },
              {
                max: 24,
                message: '案例标题字数不能多于24个字'
              },
              {
                validator: checkEmoji
              }
            ]
          })(
            <CheckInput
              style={{ width: 440 }}
              placeholder="请输入案例的展示名称，建议名称总长度在12-24字"
              maxLength={24}
              suffix={`${getFieldValue('title').length}/24`}
              getfielderror={getFieldError}
              type={1}
            />
          )}
        </FormItem>
        <FormItem
          label="参考价格"
          {...formItemLayout}
          extra="参考价格包含方案策划、现场布置、服务人员 (如管家、督导，不含四大金刚) 等"
        >
          {getFieldDecorator('caseReference', {
            initialValue: form_default.caseReference,
            rules: [
              {
                required: true,
                message: '请输入参考价格'
              },
              {
                validator: (rule, value) => {
                  if (value % 1 > 0) {
                    return Promise.reject('参考价格不可输入小数')
                  } else {
                    return Promise.resolve()
                  }
                }
              }
            ]
          })(
            <InputPrice
              placeholder={
                grayTestFlag && '请输入案例的真实价格，审核通过后将不可修改'
              }
              onClick={() => {
                // 案例整改通过后提示不可更改参考价
                form_default.caseReference &&
                  disabled &&
                  message.error('已通过审核的案例无法修改参考价')
              }}
              disabled={form_default.caseReference && disabled}
            />
          )}
        </FormItem>
        <FormItem label="婚礼日期" {...formItemLayout}>
          {getFieldDecorator('wedding_date', {
            initialValue: form_default.wedding_date,
            rules: [
              {
                required: true,
                message: '请选择婚礼日期'
              }
            ]
          })(
            <DatePicker
              placeholder={
                grayTestFlag
                  ? '请输入案例的真实婚礼日期，审核通过后将不可修改'
                  : '请选择婚礼日期'
              }
              onClick={() => {
                // 案例整改通过后提示不可更改日期
                form_default.wedding_date &&
                  disabled &&
                  message.error('已通过审核的案例无法修改日期')
              }}
              disabled={form_default.wedding_date && disabled}
              style={{ width: 380 }}
            />
          )}
        </FormItem>
        <FormItem label={'婚礼地点'} {...formItemLayout}>
          {getFieldDecorator('hotel_name', {
            initialValue: form_default.hotel_name || '',
            rules: [
              {
                required: true,
                message: '请填写婚礼地点'
              },
              {
                validator: (_, value, callback) => {
                  setTimeout(() => {
                    const hallId = getFieldValue('hotel_hall_id')
                    if (
                      value &&
                      hallId == null &&
                      hotelBallroom?.length &&
                      hotels?.length
                    ) {
                      return callback('请选择宴会厅')
                    }
                    callback()
                  })
                }
              }
            ]
          })(
            <WeddingPlace
              onClick={() => {
                // 案例整改通过后提示不可更改婚礼地点
                form_default.hotel_name &&
                  disabled &&
                  message.error('已通过审核的案例无法修改地点')
              }}
              placeholder={
                grayTestFlag
                  ? '请输入酒店/场地名称，审核通过后将不可修改'
                  : '请输入酒店/场地名称'
              }
              disabled={form_default.hotel_name && disabled}
              defaultHallId={form_default.hotel_hall_id}
              defaultHotelId={form_default.hotel_id}
              getFieldValue={getFieldValue}
              getFieldDecorator={getFieldDecorator}
              clearHotelBallroom={clearHotelBallroom}
              setFieldsValue={setFieldsValue}
              hotels={hotels}
              hotelBallroom={hotelBallroom}
              onSearchHotelBallroom={onSearchHotelBallroom}
              formItemLayout={formItemLayout}
              onSearchHotel={onSearchHotel}
              getFieldError={getFieldError}
            />
          )}
        </FormItem>
        {/* 婚纱礼服12 可以上传横图和竖图 */}
        <FormItem
          label="案例封面"
          className={styles.coverPath}
          {...formItemLayout}
        >
          {getFieldDecorator('cover_path', {
            initialValue: form_default.cover_path,
            rules: [
              {
                required: true,
                message: '请上传封面图'
              },
              {
                validator: validatorCoverPath
              }
            ]
          })(<CoverImageUpload isMutile checkCMYK={checkCMYK} />)}
        </FormItem>
        <FormItem label="头图视频" {...formItemLayout}>
          {getFieldDecorator('cover_video', {
            initialValue: form_default.cover_video
          })(<CoverVideoUpload />)}
        </FormItem>

        <PlanField
          getFieldDecorator={getFieldDecorator}
          setFieldsValue={setFieldsValue}
          hotels={hotels}
          formItemLayout={formItemLayout}
          onSearchHotel={onSearchHotel}
          form_default={form_default}
          getFieldError={getFieldError}
        />

        {!!getMerchantInfo()?.is_franchisee &&
          getMerchantInfo()?.is_franchisee != 0 && (
            <FormItem label="案例类目" {...formItemLayout}>
              {getFieldDecorator('property_id', {
                initialValue: form_default.property_id,
                rules: [
                  {
                    required: true,
                    message: '请选择案例类目'
                  }
                ]
              })(
                <Select
                  placeholder="案例类目"
                  style={{ width: 200 }}
                  onChange={setPropertyId}
                >
                  <Select.Option value="">请选择案例类目</Select.Option>
                  {properties &&
                    properties.map((item, index) => {
                      return item.id != 1 ? (
                        <Select.Option value={item.id} key={index}>
                          {item.name}
                        </Select.Option>
                      ) : null
                    })}
                </Select>
              )}
            </FormItem>
          )}
        {/* 只有在门店开通水镜，同时是新建婚礼纪案例的情况下，已经支付，不是来自水镜，才显示以下选项 */}
        {this.showShuiJing(is_add_form, isFromShuijing) && (
          <>
            <Form.Item {...formItemLayout} label="展示到水镜">
              {getFieldDecorator('_show_in_shuijing', {
                initialValue: form_default._show_in_shuijing
              })(
                <Radio.Group>
                  <Radio value="1">是</Radio>
                  <Radio value="0">否</Radio>
                </Radio.Group>
              )}
            </Form.Item>
            {_show_in_shuijing === '1' && (
              <FormItem label="水镜中展示位置" {...formItemLayout}>
                {getFieldDecorator('_mirror_category_id', {
                  initialValue: form_default._mirror_category_id,
                  rules: [{ required: true, message: '添加至水镜的展示位置' }]
                })(
                  <TreeSelect
                    multiple
                    allowClear
                    treeData={toJS(shuijingCategoryList)}
                    style={{ width: 440 }}
                    placeholder="请选择展示位置"
                    treeDefaultExpandAll
                  />
                )}
              </FormItem>
            )}
          </>
        )}

        {top_wedding && (
          <FormItem className={'tags'} label={'高定标签'} {...formItemLayout}>
            {topWeddingTags?.map(({ id, name }, i) => {
              return (
                <CheckableTag
                  key={i}
                  checked={(selectedTopWeddingTag || []).some(
                    item => item == id
                  )}
                  className="border"
                  onChange={changeTopWeddingTags(id)}
                >
                  {name}
                </CheckableTag>
              )
            })}
          </FormItem>
        )}
      </RouterView>
    )
  }
}

export default BaseInfo
